import { useEffect, useState } from "react";
import AppNavBar from "../components/AppNavBar";
import Landing from "../components/home/1-landing/Landing";
import { GetServerSideProps } from "next";
import Seo from "../components/Seo";

// Dynamic Imports
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
const Stats = dynamic(() => import("../components/home/2-stats/Stats"));
const TheProcess = dynamic(
  () => import("../components/home/3-the-process/TheProcess")
);
const Investors = dynamic(
  () => import("../components/home/4b-investors/Investors")
);
const Features = dynamic(
  () => import("../components/home/4-features/Features")
);
const FeatureScroll = dynamic(
  () => import("../components/home/4-features/FeatureScroll")
);
const OurProducts = dynamic(
  () => import("../components/home/5-our-products/OurProducts")
);
const Brand = dynamic(() => import("../components/home/6-brands/Brand"));
const Testimonials = dynamic(
  () => import("../components/home/7-testimonials/Testimonials")
);
const Blogs = dynamic(() => import("../components/home/8-blogs/Blogs"));
const Press = dynamic(() => import("../components/home/9-press/Press"));
const AppFooter = dynamic(() => import("../components/AppFooter"));
const ApplicationCTA = dynamic(() => import("../components/ApplicationCTA"));
const ElevenLabsBadge = dynamic(() => import("../components/ElevenLabsBadge"));

interface HomeProps {
  initialNavColor: string;
}

const Home: React.FC<HomeProps> = ({ initialNavColor }) => {
  const [navColor, setNavColor] = useState(initialNavColor);



  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setNavColor("#002561");
      } else {
        setNavColor("transparent");
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Set the initial color based on the current scroll position

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Seo
        title="GroMo: Sell Financial Products & Earn 1 Lakh/Month | Zero Investment"
        description="Gromo is India's best real money earning app to earn extra income online without investment. Become a Gromo partner to Sell financial products & earn real money."
        keywords="GroMo Money Making Application, पैसे कमाने वाला ऐप, बिना निवेश कमाई, घर बैठे कमाई, ऑनलाइन पैसे कमाए"
        openGraph={{
          title:
            "GroMo — Sell Financial Products & Earn ₹1 Lakh/Month | 60L+ Partners | Shark Tank India' Description: 'India’s largest financial product distribution platform. 60L+ partners. Sell credit cards, loans, savings accounts. Zero investment. Instant payouts. Y Combinator backed.",
          description:
            "Gromo is India's best real money earning app to earn extra income online without investment. Become a Gromo partner to Sell financial products & earn real money.",
          type: "website",
          image:
            "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
        }}
        twitter={{
          title: "Become A Certified Financial Advisor, Earn Money up to ₹1 Lakh",
          description:
            "Become a partner and make a regular income by selling financial products. Brand yourself as a certified financial advisor and launch and grow your business.",
          url: "https://gromo.in",
          image:
            "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
        }}
      >
        <meta
          name="facebook-domain-verification"
          content="h5cwilbbvtk9ui5zbw1dn1i47ohmj1"
        />
      </Seo>
      <AppNavBar navBgColor={navColor} />
      <Landing />
      <Stats />
      <TheProcess />
      <Investors />
      <Features />
      <FeatureScroll />
      <OurProducts />
      <Brand />
      <Testimonials />
      <Press />
      <Blogs heading="GroMo Blogs" />
      <ApplicationCTA />
      <ElevenLabsBadge />
      <AppFooter />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  const initialNavColor = "transparent";
  return { props: { initialNavColor } };
};

export default Home;
